import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form, {RESTRICTIONS, STATUSES, TYPES, prepareValuesForSubmission, validateForm} from "./PromoCodeForm";
import {cancelCreatePromoCode} from "../../actions/SalesApiActions";
import {showDatePicker} from "../../actions/ViewActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";


class CreatePromoCodeFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const updatedValues = prepareValuesForSubmission(values);

    return this.props.createPromoCode(updatedValues.toJS())
      .then((response) => {
        if (response.data.createPromoCode.errors.length <= 0) {
          // Success
          this.handleCancel();
        } else {
          console.log(response.data.createPromoCode.errors)
          let errors = createValidationErrors(response.data.createPromoCode.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelCreatePromoCode();
  }

  render() {
    // Default values
    const initialValues = fromJS({
      status: STATUSES.ENABLED,
      type: TYPES.ONBOARDING,
      subscriptionsOnly: true,
      restrictionType: RESTRICTIONS.NONE,
      restrictionId: "", // Cannot be null
      limit: 0,
      maxItemsPerUsage: 0,
      percentagex100: 50,
      expires: false,
      expiryDate: "", // Cannot be null
      tagRules: "", // Must be a string
      // Select appropriate items ("selected" attr is scrapped before mutation)
      items: [
        {type: "sku", id: "WAT-HAL-STL-05", limit: 0, selected: true},
        {type: "sku", id: "WAT-HAL-STL-6PC-750", limit: 0, selected: true},
        {type: "sku", id: "WAT-HAL-STL-8PC-750", limit: 0, selected: true},
      ],
    })

    return (
      <Form
        {...this.props}
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        showDatePicker={this.props.showDatePicker}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CREATE_PROMO_CODE = gql`
  mutation createPromoCode($data: CreatePromoCodeInput!) {
    createPromoCode(input: $data) {
      errors { key message }
    }
  }
`;


const withQuery = compose(
  graphql(CREATE_PROMO_CODE, {
    props: ({ mutate }) => ({
      createPromoCode: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const CreatePromoCodeFormContainerWithData = withQuery(CreatePromoCodeFormContainer);

const selector = formValueSelector("PromoCodeForm");
function mapStateToProps(state, ownProps) {
  return {
    codeType: selector(state, "type"),
    codeJurisdiction: selector(state, "jurisdiction"),
    restrictionType: selector(state, "restrictionType"),
    expires: !!selector(state, "expires"), // Coerce to boolean
  }
}

export default connect(mapStateToProps, {cancelCreatePromoCode, showDatePicker})(CreatePromoCodeFormContainerWithData);